module.exports = __webpack_public_path__ + "img/02-04-img-02.5a0f929f.png";